export * from './Cms';
export * from './address';
export * from './article';
export * from './leagueTable';
export * from './match';
export * from './team';
export * from './competition';
export * from './sponsor';
export * from './tag';
export * from './contact';
export * from './socialNetwork';
export * from './navigation';
export * from './job';
export * from './settings';
export * from './user';
export * from './asset';
export * from './tenant';
export * from './faq';
export * from './socketEvent';
export * from './liveFeed';
export * from './releaseNote';
export * from './video';

export type Option = {
  value: string;
  label: string;
  isSelected?: boolean;
};

export enum DeviceType {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export enum StickyPosition {
  Sidebar = 'sidebar',
  Footer = 'footer',
}

export type ImageFile = File & { preview: string };

export enum ArticleSort {
  Title = 'title',
  Date = 'date',
}

export enum ArticleOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export enum TagsMatchMode {
  All = 'all',
  Any = 'any',
}

export enum SortOrder {
  Newest = 'newest',
  Oldest = 'oldest',
}

export enum ArticleVariant {
  Default = 'default',
  TextSideBySide = 'text-side-by-side',
}

export type Pagination = {
  currentPage: number;
  totalItems: number;
  totalPages: number;
  hasNextPage: boolean;
};

export interface PaginatedResponse<T> {
  items: T[];
  pagination: Pagination;
}
